/* Stalenkiezer: telt de aangevinkte stalen, toont ze in de balk onderin en zet
   ze in één keer in de winkelwagen. Zonder dit script werkt het formulier nog
   steeds: het post dan gewoon naar /cart/add. */
(function () {
  var MAX_THUMBS = 5;

  function init(root) {
    var form = root.querySelector('[data-stalen-form]');
    var balk = root.querySelector('[data-stalen-balk]');
    if (!form || !balk) return;

    var thumbs = balk.querySelector('[data-stalen-thumbs]');
    var teller = balk.querySelector('[data-stalen-aantal]');
    var knop = balk.querySelector('[data-stalen-knop]');
    var wis = balk.querySelector('[data-stalen-wis]');
    var fout = balk.querySelector('[data-stalen-fout]');
    var knopTekst = knop.textContent;
    var cartUrl = form.getAttribute('data-cart-url') || '/cart';
    var bezig = false;

    function vakjes() {
      return [].slice.call(form.querySelectorAll('[data-staal]'));
    }
    function gekozen() {
      return vakjes().filter(function (v) {
        return v.checked && !v.disabled;
      });
    }
    function inWagen() {
      return vakjes().filter(function (v) {
        return v.hasAttribute('data-in-wagen');
      });
    }

    function toonFout(tekst) {
      fout.textContent = tekst || '';
      fout.hidden = !tekst;
    }

    function werkBij() {
      var keuze = gekozen();
      var n = keuze.length;
      var alIn = inWagen().length;

      thumbs.textContent = '';
      keuze.slice(0, MAX_THUMBS).forEach(function (v) {
        var src = v.getAttribute('data-beeld');
        if (!src) return;
        var img = document.createElement('img');
        img.src = src;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        thumbs.appendChild(img);
      });
      if (n > MAX_THUMBS) {
        var meer = document.createElement('span');
        meer.className = 'stalen-balk__meer';
        meer.textContent = '+' + (n - MAX_THUMBS);
        thumbs.appendChild(meer);
      }

      if (n > 0) {
        teller.textContent = n + (n === 1 ? ' staal gekozen' : ' stalen gekozen');
        knop.textContent = knopTekst;
        wis.hidden = false;
      } else if (alIn > 0) {
        teller.textContent = alIn + (alIn === 1 ? ' staal' : ' stalen') + ' in uw winkelwagen';
        knop.textContent = 'Naar winkelwagen';
        wis.hidden = true;
      }

      var open = n > 0 || alIn > 0;
      balk.classList.toggle('is-open', open);
      root.classList.toggle('heeft-keuze', open);
      // Voor wat buiten de sectie staat en moet opschuiven, zoals de chatknop.
      document.documentElement.classList.toggle('stalen-balk-open', open);
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-staal')) {
        toonFout('');
        werkBij();
      }
    });

    wis.addEventListener('click', function () {
      gekozen().forEach(function (v) {
        v.checked = false;
      });
      toonFout('');
      werkBij();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (bezig) return;

      var gevinkt = gekozen();
      // Wat al in de winkelwagen ligt, gaat er niet nog een keer in.
      var keuze = gevinkt.filter(function (v) {
        return !v.hasAttribute('data-in-wagen');
      });
      if (!keuze.length) {
        // Niets nieuws om toe te voegen: door naar de winkelwagen.
        if (gevinkt.length || inWagen().length) window.location.href = cartUrl;
        return;
      }

      bezig = true;
      knop.disabled = true;
      knop.textContent = 'Bezig…';
      toonFout('');

      fetch(form.getAttribute('action') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: keuze.map(function (v) {
            return { id: Number(v.value), quantity: 1 };
          }),
        }),
      })
        .then(function (res) {
          return res
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || '');
              window.location.href = cartUrl;
            });
        })
        .catch(function (err) {
          bezig = false;
          knop.disabled = false;
          knop.textContent = knopTekst;
          toonFout(
            (err && err.message ? err.message + ' ' : '') +
              'De stalen zijn niet toegevoegd. Probeer het opnieuw of neem contact met ons op.'
          );
        });
    });

    // Vergroten met de Fancybox van het thema. Ontbreekt die, dan opent de
    // link de grote afbeelding in een nieuw tabblad.
    if (window.Fancybox && typeof window.Fancybox.bind === 'function') {
      window.Fancybox.bind(root, '[data-fancybox="stalen"]', {});
    }

    // Een productpagina linkt hierheen met ?staal=handle (meerdere met een
    // komma). Die stalen staan dan al aangevinkt en de pagina schuift ernaartoe.
    function kiesUitAdres() {
      var params;
      try {
        params = new URLSearchParams(window.location.search);
      } catch (e) {
        return;
      }
      var handles = params
        .getAll('staal')
        .join(',')
        .split(',')
        .map(function (h) {
          return h.trim();
        })
        .filter(Boolean);
      if (!handles.length) return;

      var eerste = null;
      vakjes().forEach(function (v) {
        if (v.disabled || handles.indexOf(v.getAttribute('data-handle')) === -1) return;
        v.checked = true;
        if (!eerste) eerste = v;
      });

      // Uit het adres halen, zodat verversen de keuze niet opnieuw afdwingt.
      params.delete('staal');
      var rest = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (rest ? '?' + rest : '') + window.location.hash);

      if (eerste) {
        var kaart = eerste.closest('.stalen-kaart');
        if (kaart) kaart.scrollIntoView({ block: 'center' });
      }
    }

    root.classList.add('stalen--js');
    kiesUitAdres();
    werkBij();
  }

  function start() {
    [].slice.call(document.querySelectorAll('[data-stalen]')).forEach(function (root) {
      if (root.hasAttribute('data-stalen-klaar')) return;
      root.setAttribute('data-stalen-klaar', '');
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // De themabewerker laadt een sectie opnieuw zonder de pagina te verversen.
  document.addEventListener('shopify:section:load', start);
})();
